// https://github.com/ohansemmanuel/fake-medium/tree/4eb6cf0ee6feb1c7fbb43000a12407ea46ac9907/src/middleware
// inspired by https://leanpub.com/redux-book
import axios from 'axios';
import { API } from '../actions';
import { accessDenied, apiError, apiStart, apiEnd } from '../actions';
import { actions as notificationActions } from '../../../notification';

//could use this if necessary to deal with the forwarding issues, so far we're ok
const BASE_URL = '';

const HTTP_UNAUTHORIZED = 401;
const HTTP_ACCESS_DENIED = 403;
const HTTP_UNPROCESSABLE_ENTITY = 422;
const HTTP_INTERNAL_SERVER_ERROR = 500;

// note currently the webpack dev server users Accept header to decide what to proxy,
// if we change this, we need to ensure we don't break that as well.
// (i.e. if you change this and the webpack dev server stops proxying, it will need to be tweaked)
const defaultHeaders = {
    Accept: 'application/json',
};
let headers = { ...defaultHeaders };

const apiMiddleware =
    ({ dispatch, getState }) =>
    (next) =>
    (action) => {
        next(action);
        if (action.type !== API) return;

        const {
            url,
            method,
            data,
            onSuccess,
            onFailure,
            onFailureAction,
            label,
            headersOverride,
            withCredentials = true,
            apiActionPayload,
        } = action.payload;

        const dataOrParams = ['GET', 'DELETE'].includes(method) ? 'params' : 'data';

        if (headersOverride) {
            headers = {
                ...headers,
                ...headersOverride,
            };
        }

        const requestStartTime = Date.now();
        if (label) {
            dispatch(apiStart(label, requestStartTime, apiActionPayload));
        }
        axios
            .request({
                url: `${BASE_URL}${url}`,
                method,
                headers,
                withCredentials,
                [dataOrParams]: data,
            })
            .then(handleResponse)
            .catch(handleError)
            .finally(() => {
                if (label) {
                    dispatch(apiEnd(label, requestStartTime, apiActionPayload));
                }
            });

        function handleResponse({ data, status }) {
            if (onSuccess) {
                const onSuccessAction = onSuccess(data, requestStartTime, apiActionPayload);
                if (onSuccessAction) {
                    dispatch(onSuccessAction);
                }
            }
        }

        function handleDisplayableError(errData) {
            const snackbarMessage =
                errData?.clientMessage ?? 'User not authenticated. Please login.';
            const snackbarType = errData?.displayAsError ? 'error' : 'info';
            dispatch(
                notificationActions.showSnackbar({
                    snackbarMessage,
                    snackbarType,
                })
            );
        }

        function handleError(error) {
            let errData;
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                if (error.response.data) {
                    errData = error.response.data;
                }
                switch (error.response.status) {
                    case HTTP_ACCESS_DENIED:
                        // TODO here write our handler
                        dispatch(accessDenied(window.location.pathname));
                        break;
                    case HTTP_UNAUTHORIZED:
                        //const state = getState();
                        handleDisplayableError(errData);
                        break;
                    case HTTP_INTERNAL_SERVER_ERROR:
                        console.log('HTTP_INTERNAL_SERVER_ERROR');
                        break;
                    case HTTP_UNPROCESSABLE_ENTITY:
                        handleDisplayableError(errData);
                        break;
                    default:
                }
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log('No response recieved', error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }

            dispatch(apiError(error, apiActionPayload));

            if (onFailureAction) {
                dispatch(onFailureAction(error, errData));
            }

            if (onFailure) {
                const failureAction2 = onFailure(error, errData, requestStartTime);
                if (failureAction2) {
                    dispatch(failureAction2);
                }
            }
        }
    };

export default apiMiddleware;
